export default __webpack_public_path__ + "static/media/homeCarInsurance.540493cc.svg";